module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-up-5d51cf8c.svg";